/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Support_UsInputs */



/**
* | output |
* | --- |
* | "Support us" |
*
* @param {Footer_Support_UsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const footer_support_us = /** @type {((inputs?: Footer_Support_UsInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Support_UsInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Unterstütze uns")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Soutenez-nous")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("支持我们")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("支持我們")
	if (locale === "ko") return /** @type {LocalizedString} */ ("후원하기")
	return /** @type {LocalizedString} */ ("Support us")
});